import { useMembership } from "@/hooks/useMembership";
import { useHideCommerce } from "@/lib/native-app";

/**
 * Single source of truth for whether "Join / Sign up / Become a member"
 * purchase prompts may be shown.
 *
 * - Active members (and admins, who resolve as members) never see them.
 * - While membership is still being checked, prompts stay hidden so a
 *   signed-in member never sees a brief logged-out/non-member flash.
 * - Signed-out visitors and signed-in non-members see them once confirmed.
 */
export function useMembershipCta() {
  const m = useMembership();
  const pending = !m.hydrated || m.loading;
  const isActiveMember = !pending && m.isMember;
  const hideCommerce = useHideCommerce();
  // Inside the iOS app nothing may lead to a purchase.
  const showJoinCta = !pending && !m.isMember && !hideCommerce;
  return { pending, isActiveMember, showJoinCta, isAuthed: m.isAuthed };
}
